import { BellRing, Gift, ScanLine } from 'lucide-react';
import { Card } from '@/shared/ui/card';
import type { PublicInvitePassbook } from '@/features/public-invite/api/use-public-invite';
import type { ParticipantTier } from '../../api/participant-api';
import { WalletCardActions } from '../wallet-card-actions';
import { WalletCardPreview } from '../wallet-card-preview';

interface CardTabProps {
  passbook: PublicInvitePassbook;
  serialNumber: string;
  holderName?: string;
  balance?: string;
  accentColor?: string;
  foregroundColor?: string;
  tier?: ParticipantTier | null;
}

const PERKS = [
  { icon: ScanLine, text: 'Mostre no caixa para pontuar e resgatar' },
  { icon: Gift, text: 'Saldo e prêmios sempre à mão' },
  { icon: BellRing, text: 'Avisos da loja direto no celular' },
];

/** "Meu cartão": prévia do cartão + o botão certo para pôr na carteira do celular. */
export function CardTab({
  passbook,
  serialNumber,
  holderName,
  balance,
  accentColor,
  foregroundColor,
  tier,
}: CardTabProps) {
  return (
    <div className="mx-auto w-full max-w-xl space-y-5">
      <WalletCardPreview
        passbook={passbook}
        holderName={holderName}
        balance={balance}
        serialNumber={serialNumber}
        tier={tier}
      />
      <Card className="space-y-5 p-5 text-center sm:p-6">
        <div className="space-y-1.5">
          <h3 className="text-base font-semibold">Seu cartão na carteira do celular</h3>
          <p className="text-sm text-muted-foreground">Sem precisar entrar aqui toda vez.</p>
        </div>
        <ul className="grid gap-2 text-left sm:grid-cols-3">
          {PERKS.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-center gap-2.5 rounded-xl bg-muted/50 px-3 py-2.5 text-xs sm:flex-col sm:text-center">
              <Icon className="size-4 shrink-0 text-muted-foreground" />
              <span>{text}</span>
            </li>
          ))}
        </ul>
        <WalletCardActions
          passbook={passbook}
          serialNumber={serialNumber}
          accentColor={accentColor}
          foregroundColor={foregroundColor}
        />
      </Card>
    </div>
  );
}
